import { AlertIcon } from '@approvalmax/ui';
import { Alert, Box, Grid, Label, Text } from '@approvalmax/ui/src/components';
import random from 'lodash/random';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useIsSubmitAvailable } from '../../../../resources/hooks/useIsSubmitAvailable';
import { useSummaryFields } from './Summary.hooks';
import { messages } from './Summary.messages';

export const Summary = memo(() => {
    const {
        companyName,
        destCountries,
        currenciesPayOut,
        currenciesSendIn,
        directors,
        owners,
        isLoading,
        isCountriesLoading,
    } = useSummaryFields();
    const { isSubmitAvailable } = useIsSubmitAvailable();

    return (
        <>
            <Box bordered radius='small'>
                <Box spacing='16 24'>
                    <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                        {messages.title}
                    </Text>
                </Box>

                <Grid gap={16} padding='0 24 16'>
                    <div>
                        <Label size='medium'>{messages.companyName}</Label>

                        <Text font='label' fontSize='medium' fontWeight='regular'>
                            {isLoading ? <Skeleton width={random(100, 200)} /> : companyName}
                        </Text>
                    </div>

                    <div>
                        <Label size='medium'>{messages.destCountries}</Label>

                        <Text font='label' fontSize='medium' fontWeight='regular'>
                            {isLoading || isCountriesLoading ? <Skeleton width={random(100, 200)} /> : destCountries}
                        </Text>
                    </div>

                    <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                        <div>
                            <Label size='medium'>{messages.currenciesPayOut}</Label>

                            <Text font='label' fontSize='medium' fontWeight='regular'>
                                {isLoading ? <Skeleton width={random(50, 100)} /> : currenciesPayOut}
                            </Text>
                        </div>

                        <div>
                            <Label size='medium'>{messages.currenciesSendIn}</Label>

                            <Text font='label' fontSize='medium' fontWeight='regular'>
                                {isLoading ? <Skeleton width={random(50, 100)} /> : currenciesSendIn}
                            </Text>
                        </div>
                    </Grid>

                    <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                        <div>
                            <Label size='medium'>{messages.directors}</Label>

                            <Text font='label' fontSize='medium' fontWeight='regular'>
                                {isLoading ? <Skeleton width={random(50, 100)} /> : directors}
                            </Text>
                        </div>

                        <div>
                            <Label size='medium'>{messages.owners}</Label>

                            <Text font='label' fontSize='medium' fontWeight='regular'>
                                {isLoading ? <Skeleton width={random(50, 100)} /> : owners}
                            </Text>
                        </div>
                    </Grid>
                </Grid>
            </Box>

            {!isSubmitAvailable && (
                <Alert color='red20' size='small' startIcon={<AlertIcon />}>
                    {messages.needToWait}
                </Alert>
            )}
        </>
    );
});

Summary.displayName = 'Summary';
